export default __webpack_public_path__ + "static/media/crowd.ac053e07.webp";